import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { EntityMemberCommunicationType, entityMemberCommunicationTypeLabels } from '@state/entities';

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'fl-message-communication-types',
  styleUrls: ['./message-communication-types.component.scss'],
  templateUrl: './message-communication-types.component.html'
})
export class MessageCommunicationTypesComponent implements OnInit {
  @Input() communicationTypes: EntityMemberCommunicationType[] = [];
  @Input() selectAllLabel = 'Receive all communications?';
  @Input() disabled = false;
  @Output() communicationTypesChange = new EventEmitter<EntityMemberCommunicationType[]>();

  availableEntityMemberCommunicationTypes = Object.entries(EntityMemberCommunicationType).map(
    ([key, value]) => ({ key, value })
  );
  allSelected: boolean;
  entityMemberCommunicationTypeSelections = new Map<EntityMemberCommunicationType, boolean>();
  entityMemberCommunicationTypeLabels = entityMemberCommunicationTypeLabels;

  constructor() {}

  ngOnInit() {
    this.allSelected =
      this.communicationTypes?.length === this.availableEntityMemberCommunicationTypes.length;

    for (let type of this.communicationTypes) {
      this.entityMemberCommunicationTypeSelections.set(type, true);
    }
  }

  emitNewSelections(): void {
    let newSelections: EntityMemberCommunicationType[] = [];

    for (let [type, selected] of this.entityMemberCommunicationTypeSelections) {
      if (selected) newSelections.push(type);
    }

    this.communicationTypesChange.emit(newSelections);
  }

  toggleAll({ checked }: MatSlideToggleChange): void {
    if (!checked) return;

    for (let type of this.availableEntityMemberCommunicationTypes) {
      this.entityMemberCommunicationTypeSelections.set(type.value, true);
    }

    this.emitNewSelections();
  }

  toggleOption(change: MatCheckboxChange): void {
    this.emitNewSelections();
    if (change.checked) return;

    if (this.allSelected) this.allSelected = false;
  }
}
